import React from 'react';
import cx from 'classnames';
import { Typography } from '../../core';
import * as styles from './ListView.module.css';

interface ListViewItem {
  key?: string;
  title: string;
  subtitle?: string | null;
  subtitleNode?: React.ReactNode;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  button?: React.ReactNode;
  selected?: boolean;
}

interface ListViewProps {
  list?: ListViewItem[];
  onClick?: ((item: ListViewItem) => void) | null;
}

function ListView({ list = [], onClick = null }: ListViewProps) {
  return (
    <div className={styles.list}>
      {list.map(item => (
        <div
          key={item.key || item.title}
          className={cx(
            styles.item,
            onClick && styles.clickable,
            item.selected && styles.selected,
          )}
          onClick={onClick ? () => onClick(item) : undefined}
          role={onClick ? 'button' : undefined}
          data-testid="listview-item"
        >
          {item.startIcon && (
            <div className={styles.startIcon}>{item.startIcon}</div>
          )}

          <div className={styles.content}>
            <Typography variant="label" fontWeight="medium" color="#9b9b9b">
              {item.title}
            </Typography>
            {item.subtitleNode}
            {!item.subtitleNode && item.subtitle && (
              <Typography variant="label" fontWeight="medium" color="black">
                {item.subtitle}
              </Typography>
            )}
          </div>

          {item.endIcon && <div className={styles.endIcon}>{item.endIcon}</div>}
          {item.button && <div className={styles.button}>{item.button}</div>}
        </div>
      ))}
    </div>
  );
}

export default ListView;
